import React from 'react';
import { useSelector } from 'react-redux';
import styles from './EventName.module.scss';
import { findName } from '../../../../../utils/render';

const EventName = ({ eventName, teams }) => {
    const { locale } = useSelector(state => state.settings);

    return (
        <span className={styles.eventName}>
            {eventName || (teams ? `${findName(teams.home, locale)} - ${findName(teams.away, locale)}` : '')}
        </span>
    );
};

export default EventName;
